import { UPDATE_INDUSTRIES } from "../constants";

const initialState = null;

export const setIndustriesData = (data) => ({
    type: UPDATE_INDUSTRIES,
    data,
});

export const industries = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_INDUSTRIES:
            return action.data;
        default:
            return state;
    }
};